import React from "react";
import R from "ramda";
import styled from "styled-components";

import {
	gql,
	graphql,
	compose,
} from 'react-apollo';

//------------------------------

const OrgImage = styled.div`
	background-color: white;
	border-radius: 4px ;
	height: 40px;
	margin: 4px;
	padding: 4px;
	width: 40px;
`;

const getUserID = gql`
	query getUserID {
		viewer{
			user {
				id
			}
		}
	}
`;

const createNewOrg = gql`
	mutation CreateNewOrg($myID: ID!) {
		createOrg(input: { ownerId: $myID name: "New Org" }) {
			changedOrg {
				id
				image {
					uri
					cloudinaryID
				}
				owner {
					id
					owns {
						edges {
							node {
								id
							}
						}
					}
				}
			}
		}
	}
`;

export default compose(
	graphql(
		getUserID,
		{
			name: "getUserID",
		},
	),

	graphql(
		createNewOrg,
		{
			props: ({ mutate, }) => ({
				addNew: (myID) => mutate({
					variables: {
						myID,
					},
				})
			}),
		},
	),

)(

	(props) => (
		( R.path([ "getUserID", "viewer", "user", "id", ], props) )
		? (
			<OrgImage 
				onClick = { () => props.addNew(
					props.getUserID.viewer.user.id
				)}
			>
				Add new
			</OrgImage>
		)
		: null
	)
)
